export function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 0) {
    const fwd = Math.abs(diff);
    const h = Math.floor(fwd / 3600000);
    if (h >= 24) return `بعد ${Math.floor(h / 24)} يوم`;
    if (h >= 1) return `بعد ${h} ساعة`;
    return `بعد ${Math.max(1, Math.floor(fwd / 60000))} دقيقة`;
  }
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'الآن';
  if (m < 60) return `منذ ${m} دقيقة`;
  const h = Math.floor(m / 60);
  if (h < 24) return `منذ ${h} ساعة`;
  return `منذ ${Math.floor(h / 24)} يوم`;
}

export function shortTime(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1);
  const sameDay = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  const hh = d.toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' });
  if (sameDay(d, today)) return `اليوم ${hh}`;
  if (sameDay(d, tomorrow)) return `غدًا ${hh}`;
  return `${d.toLocaleDateString('ar-EG', { day: 'numeric', month: 'short' })} ${hh}`;
}

export const CHANNEL_ICON: Record<string, string> = {
  whatsapp: 'ri-whatsapp-line',
  website: 'ri-global-line',
  facebook: 'ri-facebook-circle-line',
  instagram: 'ri-instagram-line',
  manual: 'ri-pencil-line',
  referral: 'ri-share-forward-line',
};

export const STAGE_LABEL: Record<string, string> = {
  new: 'جديد', contacted: 'تم التواصل', qualified: 'مؤهل', demo: 'تجريبي',
  trial: 'فترة تجربة', negotiation: 'تفاوض', won: 'تم الإغلاق', lost: 'مفقود',
};
